/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


/*  
    Product Accordion module. 
    This module reloads product tabs when user makes selections.
*/

define('modules/Product/ProductAccordion',[
    'jquery',
    'global/all'
], function ($, Roc) {
    'use strict';

    var productLandingPageUrl;

    function reloadProductAccordion(viewModel) {
        Roc.Data.getAsync({
            url: productLandingPageUrl,
            data: { id: viewModel.id },
            callback: function (data) {
                if (data && data.Success === true) {
                    var content = $(data.html).filter('.accordionModule').html();

                    $('.accordionModule').html(content);
                }
            }
        });
    }
    //Custom code : anchors
    function linkToTab() {
        Roc.UI.siteBody
            .off('click', '[id^=tab-link-]')
            .on('click', '[id^=tab-link-]', function () {
                var tabId = $(this).attr("data-roc-tabId");
                $("#tab" + tabId).trigger("click");
                $('html, body').animate({
                    scrollTop: $("#tab-content-" + tabId).offset().top - 100
                }, 1000);
            });
    }
    //End Custom code


    function init(landingPageUrl) {
        productLandingPageUrl = landingPageUrl;
        Roc.EventManager.bind(Roc.Events.products.SELECTIONS_UPDATE, reloadProductAccordion);
        //custom function
        linkToTab();
    }

    var ProductAccordion = {
        init: init
    }

    Roc.Logger.debug('ProductAccordion.js Loaded:', ProductAccordion);

    return ProductAccordion;
});
